module.exports = __webpack_public_path__ + "img/kr-product-card2-bg1.2506c11.png";